import { compose, get, over, isEmpty, keys } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { moduleSelector, IDENTITY_FORM_SECTION, PROFILE_FORM_SECTION } from './module';

export const getScannerScopes = compose(keys, moduleSelector);

const getScanner = createSelector(moduleSelector, getStringProp('scope'), (state, scope) => state[scope] || {});

export const getCustomerId = compose(get('customerId'), getScanner);

export const isOpened = compose(get('isOpened'), getScanner);

export const isFetching = compose(get('isFetching'), getScanner);

export const hasError = compose(get('hasError'), getScanner);

export const getProfileValues = compose(get('profileValues'), getScanner);

export const getDocumentValues = compose(get('documentValues'), getScanner);

export const hasValues = compose(
    ([profileValues, documentValues]) => !isEmpty(profileValues) || !isEmpty(documentValues),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    over([getProfileValues, getDocumentValues])
);

export const getProfileAndDocumentValues = createSelector(
    getDocumentValues,
    getProfileValues,
    (documentValues, profileValues) => ({
        [IDENTITY_FORM_SECTION]: documentValues,
        [PROFILE_FORM_SECTION]: profileValues,
    })
);
